import React, { Suspense } from "react";

import { Switch, Route } from "react-router-dom";

import { Loader } from "semantic-ui-react";

import Layout from "./hoc/layout";

import Auth from "./hoc/auth"

import CreateEditPromotion from "./components/Promotions/CreateEditPromotion";

const Login = React.lazy(() => import("./components/Login"));

const Profile = React.lazy(() => import("./components/Profile"));

const PageNotFound = React.lazy(() => import("./components/views/pageNotFound"));

const Promotion = React.lazy(() => import("./components/Promotions"));

const EditOrCreatePromotion = React.lazy(() => import("./components/Promotions/CreateEditPromotion"))

const ManagePassword = React.lazy(() => import("./components/ManagePassword"));

const HotelRegister = React.lazy(() => import("./components/RegisterHotel"));

const AdminRegistration = React.lazy(() => import("./components/AdminRegistration"));

const UnlistedClosedHotels = React.lazy(() => import("./components/UnlistedClosedHotels"));

const BulkAccountSearch = React.lazy(() => import("./components/bulkAccountSearch"));

const BulkAdminSearch = React.lazy(() => import("./components/bulkAdminSearch"));

const HotelBalanceList = React.lazy(() => import("./components/Finance/hotelBalanceList"));

const Ledger = React.lazy(() => import("./components/Finance"));

const LedgerNew = React.lazy(() => import("./components/Finance New"))

const GlobalPlatformCharges = React.lazy(() => import("./components/GlobalPlatformCharges"))

const HotelPlatformCharges = React.lazy(() => import("./components/HotelPlatfornCharges"));

const ExperienceBooking = React.lazy(() => import("./components/ExperienceBooking"));

const AdminPermissions = React.lazy(() => import("./components/AdminPermissions"));

const Payment = React.lazy(() => import("./components/Payment"));

const ActivityLogs = React.lazy(() => import("./components/ActivityLogs"));

const SiteUserDetails = React.lazy(() => import("./components/SiteUser/siteUserDetails"));

const SystemAdmin = React.lazy(() => import("./components/SystemAdmin"))

const Seo = React.lazy(() => import("./components/SEO"));

const OldSeo = React.lazy(() => import("./components/SEOOld"));

const Manageseo = React.lazy(() => import("./components/SEOOld/manageSeo"));

const NewManageSeo = React.lazy(() => import("./components/SEO/EditSEO"));

const Coupon = React.lazy(() => import("./components/Coupons"));

const manageCoupon = React.lazy(() => import("./components/Coupons/manageCoupon"));

const CouponAnalytics = React.lazy(() => import("./components/Coupons/CouponAnalytics"));

const SiteUser = React.lazy(() => import("./components/SiteUser"));

const HotelAnalytics = React.lazy(() => import("./components/INCAnalytics/hotelanalytics"));

const DateHotellist = React.lazy(() => import("./components/INCAnalytics/hotelDateList"));

const Analytics = React.lazy(() => import("./components/INCAnalytics"));

const HotelAnalyticsNew = React.lazy(() => import("./components/INCAnalyticsNew/hotelanalytics"));

const DateHotellistNew = React.lazy(() => import("./components/INCAnalyticsNew/hotelDateList"));

const AnalyticsNew = React.lazy(() => import("./components/INCAnalyticsNew"));

const S3Manager = React.lazy(() => import("./components/S3"));

const S3ManagerNew = React.lazy(() => import("./components/S3/bucket"));

const UploadBucketImg = React.lazy(() => import("./components/S3/uploadBucketImg"));

const editExperiences = React.lazy(() => import("./components/RegisterHotel/editExperiences"));

const insufficientPermissions = React.lazy(() => import("./components/views/insufficientPermissions"));

const BulkPopularity = React.lazy(() => import("./components/BulkPopularity"));

const PopularityTemplate = React.lazy(() => import("./components/PopularityTemplate"));

const PopularityTemplateDetails = React.lazy(() => import("./components/PopularityTemplate/TemplateDetailScreen"));

const Cityanalytics = React.lazy(() => import("./components/INCAnalytics/cityanalytics"));

const Adminanalytics = React.lazy(() => import("./components/INCAnalytics/adminanalytics"));

const CityanalyticsNew = React.lazy(() => import("./components/INCAnalyticsNew/cityanalytics"));

const AdminanalyticsNew = React.lazy(() => import("./components/INCAnalyticsNew/adminanalytics"));

const HotelInventory = React.lazy(() => import("./components/ManageInventory"));

const HotelInventoryNew = React.lazy(() => import("./components/ManageInventoryNew"));

const CityDetailAnalytics = React.lazy(() => import("./components/INCAnalytics/Citydetailanalytics"));

const CityDetailAnalyticsNew = React.lazy(() => import("./components/INCAnalyticsNew/Citydetailanalytics"));


const MarketingCampaign = React.lazy(() => import("./components/MarketingCampaign"));

const ManageCampaign = React.lazy(() => import("./components/MarketingCampaign/manageCampaign"));

const RegisterHotel_New = React.lazy(() => import("./components/RegisterHotel_New"))

const RoomCategory = React.lazy(() => import("./components/RoomCategory"))

const FullDayInventory = React.lazy(() => import("./components/FullDayInventory"));

const LocationScreen = React.lazy(() => import("./components/Location"))

const PropertySearch = React.lazy(() => import("./components/PropertySearch"))

const NearByHotelComponent = React.lazy(() => import("./components/NearByHotelSearch"))

const PropertyAccounts = React.lazy(() => import("./components/PropertyAccounts"))

const AuthApiErrorComponent = React.lazy(() => import("./hoc/authApiErrorComponent"))

const HomeComponent = React.lazy(() => import("./components/Home"))

const ChannelManagers = React.lazy(() => import("./components/ChannelManagers"))


const IPL = React.lazy(() => import("./components/IPL2025"))

const InterfaceStudio = React.lazy(() => import("./components/InterfaceStudio/Pages"))

const HomePageLogs = React.lazy(() => import("./components/InterfaceStudio/Pages/HomePageLogs"))

const ComponentPage = React.lazy(() => import("./components/InterfaceStudio/Pages/ComponentPage"))

const WebviewController = React.lazy(() => import("./components/InterfaceStudio/Pages/WebviewController"))


const Offers = React.lazy(() => import("./components/Offers"))

const HotelChain = React.lazy(() => import("./components/HotelChain"));
const HotelChainDetails = React.lazy(() => import("./components/HotelChain/HotelChainDetails"));

const SessionOverComponent = React.lazy(() => import("./components/SessionOver/index"))

const PrivacyAndSecurityComponent = React.lazy(() => import("./components/PrivacyAndSecurity"));

const Booking = React.lazy(() => import("./components/Booking"));
const Routes = (props) => {
  return (
    <Layout>
      <Suspense fallback={<Loader active />}>
        <Switch>
          <Route
            path="/hotel-balance-list"
            exact
            component={Auth(HotelBalanceList, true)}
          />

          <Route
            path="/register-hotel/:id"
            exact
            component={Auth(HotelRegister, true)}
          />

          <Route path="/profile-old" exact component={Auth(Profile, true)} />

          <Route path="/profile" exact component={Auth(Profile, true)} />

          <Route path="/system-admininstrator" exact component={Auth(SystemAdmin, true)} />

          <Route
            path="/admin-registration"
            exact
            component={Auth(AdminRegistration, true)}
          />

          <Route
            path="/password-change"
            exact
            component={Auth(ManagePassword, true)}
          />

          <Route
            path="/force-password-change"
            exact
            component={Auth(ManagePassword, false)}
          />

          <Route path="/login" exact component={Auth(Login, false)} />

          <Route
            path="/experiences"
            exact
            component={Auth(ExperienceBooking, true)}
          />

          <Route
            path="/bulk-account-search"
            exact
            component={Auth(BulkAccountSearch, true)}
          />

          <Route
            path="/bulk-admin-search"
            exact
            component={Auth(BulkAdminSearch, true)}
          />
          <Route
            path="/bulk-admin-search-new"
            exact
            component={Auth(BulkAdminSearch, true)}
          />
          <Route path="/payment/:error" exact component={Payment} />
       
          <Route
            path="/property-search"
            exact
            component={Auth(PropertySearch, true)}
          />

          <Route
            path="/nearby-hotel-search"
            exact
            component={Auth(NearByHotelComponent, true)}
          />
          <Route
            path="/nearby-hotel-search/:hotel_id/:check_in_date/:slot/:min_amount"
            exact
            component={Auth(NearByHotelComponent, true)}
          />
          <Route
            path="/activity-logs"
            exact
            component={Auth(ActivityLogs, true)}
          />
          <Route
            path="/user-permissions"
            exact
            component={Auth(AdminPermissions, true)}
          />

          <Route
            path="/unlisted-hotels"
            exact
            component={Auth(UnlistedClosedHotels, true)}
          />

          <Route path="/finance" exact component={Auth(Ledger, true)} />

          <Route path="/finance-new" exact component={Auth(LedgerNew, true)} />
          <Route path="/global-platform-charges" exact component={Auth(GlobalPlatformCharges, true)} />
          <Route path="/hotel-platform-charges" exact component={Auth(HotelPlatformCharges, true)} />

          <Route path="/coupon" exact component={Auth(Coupon, true)} />

          <Route
            path="/coupon/new-coupon"
            exact
            component={Auth(manageCoupon, true)}
          />

          <Route
            path="/coupon/edit-coupon/:key"
            exact
            component={Auth(manageCoupon, true)}
          />
          <Route
            path="/coupon/clone-coupon/:key"
            exact
            component={Auth(manageCoupon, true)}
          />
          <Route
            path="/coupon/coupon-analytics/:key"
            exact
            component={Auth(CouponAnalytics, true)}
          />

          <Route path="/seo" exact component={Auth(Seo, true)} />

          {/* <Route path="/seo-old" exact component={Auth(OldSeo, true)} /> */}

          {/* <Route
            path="/seo/edit-seo-old/:key"
            exact
            component={Auth(Manageseo, true)}
          /> */}

          {/* <Route
            path="/seo-old/edit-seo-old/:key"
            exact
            component={Auth(Manageseo, true)}
          /> */}

          {/* <Route
            path="/seo-old/edit-seo/:key"
            exact
            component={Auth(NewManageSeo, true)}
          /> */}

          <Route
            path="/seo/edit-seo/:key"
            exact
            component={Auth(NewManageSeo, true)}
          />

          <Route path="/s3/" exact component={Auth(S3Manager, true)} />
          <Route
            path="/s3/:type/upload"
            exact
            component={Auth(UploadBucketImg, true)}
          />
          <Route
            path="/s3/:type?/:key?"
            exact
            component={Auth(S3ManagerNew, true)}
          />
          <Route path="/site-user" exact component={Auth(SiteUser, true)} />
          <Route
            path="/site-user/site-user-details/:key"
            exact
            component={Auth(SiteUserDetails, true)}
          />

          <Route path="/analytics" exact component={Auth(Analytics, true)} />
                    <Route path="/analyticsNew" exact component={Auth(AnalyticsNew, true)} />

          <Route
            path="/editexperiences/:id"
            exact
            component={Auth(editExperiences, true)}
          />
          <Route
            path="/permissions-denied"
            exact
            component={Auth(insufficientPermissions, true)}
          />
          <Route
            path="/analytics/hotel-analytics"
            exact
            component={Auth(HotelAnalytics, true)}
          />
          <Route
            path="/analytics/date-hotel-list"
            exact
            component={Auth(DateHotellist, true)}
          />
          <Route
            path="/analytics/city-detail-analytics"
            exact
            component={Auth(CityDetailAnalytics, true)}
          />
          <Route
            path="/analytics/city-analytics"
            exact
            component={Auth(Cityanalytics, true)}
          />
          <Route
            path="/analytics/admin-analytics"
            exact
            component={Auth(Adminanalytics, true)}
          />

          <Route
            path="/analyticsNew/hotel-analytics"
            exact
            component={Auth(HotelAnalyticsNew, true)}
          />
          <Route
            path="/analyticsNew/date-hotel-list"
            exact
            component={Auth(DateHotellistNew, true)}
          />
          <Route
            path="/analyticsNew/city-detail-analytics"
            exact
            component={Auth(CityDetailAnalyticsNew, true)}
          />
          <Route
            path="/analyticsNew/city-analytics"
            exact
            component={Auth(CityanalyticsNew, true)}
          />
          <Route
            path="/analyticsNew/admin-analytics"
            exact
            component={Auth(AdminanalyticsNew, true)}
          />

          <Route
            path="/bulk-popularity"
            exact
            component={Auth(BulkPopularity, true)}
          />
          <Route
            path="/bulk-popularity-new"
            exact
            component={Auth(BulkPopularity, true)}
          />
          <Route
            path="/hotel-chain"
            exact
            component={Auth(HotelChain, true)}
          />
          <Route
            path="/hotel-chain-details"
            exact
            component={Auth(HotelChainDetails, true)}
          />
          <Route
            path="/popularity-template-list/"
            exact
            component={Auth(PopularityTemplate, true)}
          />
          <Route
            path="/popularity-template-details/"
            exact
            component={Auth(PopularityTemplateDetails, true)}
          />
          <Route
            path="/fullday-inventory"
            exact
            component={Auth(FullDayInventory, true)}
          />
          {/* <Route
            path="/hotel-inventory"
            exact
            component={Auth(HotelInventory, true)}
          /> */}
          <Route
            path="/hotel-inventory"
            exact
            component={Auth(HotelInventoryNew, true)}
          />
          <Route
            path="/marketing-campaign"
            exact
            component={Auth(MarketingCampaign, true)}
          />
          <Route
            path="/marketing-campaign/edit-campaign/:key"
            exact
            component={Auth(ManageCampaign, true)}
          />
          <Route path="/" exact component={Auth(HomeComponent, true)} />
          <Route path="/hotel-listing/:id" exact component={Auth(RegisterHotel_New, true)} />
          <Route path="/room-category/:id" exact component={Auth(RoomCategory, true)} />
          <Route path="/promotions" exact component={Auth(Promotion, true)} />
          <Route path="/create-promotion/:id" exact component={Auth(CreateEditPromotion, true)} />
          <Route path="/location" exact component={Auth(LocationScreen, true)} />
          <Route path="/property-accounts" exact component={Auth(PropertyAccounts, true)} />
          <Route path="/internal-server-error" exact component={Auth(AuthApiErrorComponent, true)} />
          <Route path="/channel-managers" exact component={Auth(ChannelManagers, true)} />
          <Route path="/ipl" exact component={Auth(IPL, true)} />
          <Route path="/interface-studio" exact component={Auth(InterfaceStudio, true)} />
          <Route path="/interface-studio/page-logs" exact component={Auth(HomePageLogs, true)} />
          <Route path="/interface-studio/component-page" exact component={Auth(ComponentPage, true)} />
          <Route path="/interface-studio/web-controller" exact component={Auth(WebviewController, true)} />
          <Route path="/offers" exact component={Auth(Offers, true)} />
          <Route path="/session-over" exact component={SessionOverComponent} />
          <Route path="/privacy-security" exact component={Auth(PrivacyAndSecurityComponent, true)} />
          <Route path="/bookings" exact component={Auth(Booking, true)} />
          <Route component={Auth(PageNotFound, true)} />
        </Switch>
      </Suspense>
    </Layout>
  );
};
export default Routes;
